import type {
  useFetchLifeTenants,
  useFetchLifeTenantsNoSuspense,
} from '@festina-life/api'
import {
  useAuthenticationContext,
  useGetUserRoles,
} from '@festina-life/authentication'
import { notEmpty } from '@festina-life/core'

export type Component =
  | 'legalEntity'
  | 'unitLink'
  | 'moneyOut'
  | 'moneyIn'
  | 'collCalc'
  | 'life'
  | 'dataMart'
  | 'dataMart2'

export const useGetAvailableTenants = ({
  component,
  useFetchTenants,
}: {
  component: Component
  useFetchTenants:
    | typeof useFetchLifeTenants
    | typeof useFetchLifeTenantsNoSuspense
}) => {
  const { shouldValidateAuthenticationHooks, environmentSettings } =
    useAuthenticationContext()
  const upperCaseComponent = component.toUpperCase() as Uppercase<Component>
  const isComponentAvailable =
    !!environmentSettings?.[`REACT_APP_${upperCaseComponent}_API_ENDPOINT`]

  // Get the roles for the component
  const { data: allRoles } = useGetUserRoles()
  const componentRoles = allRoles?.[component] ?? []

  const { data: tenants } = useFetchTenants(
    {},
    {
      enabled: !!isComponentAvailable,
      staleTime: 'static',
    },
  )

  // Only return the tenants that are authorized for the user
  return (
    tenants?.registeredTenants
      ?.filter(notEmpty)
      .filter((tenant) =>
        shouldValidateAuthenticationHooks
          ? componentRoles.includes(`${tenant.tenantId}.T`)
          : true,
      ) ?? []
  )
}
